// 启用关闭状态
export const enableShutdownState = [
  {
    label: '是',
    value: 'ENABLED',
  },
  {
    label: '否',
    value: 'DISABLED',
  },
];
// 任务分配方式
export const taskDistributionTypeEnum = [
  {
    label: '手动领取',
    value: 'MANUAL',
  },
  {
    label: '自动领取',
    value: 'AUTOMATIC',
  },
];
// 是否分越库
export const crossDocking = [
  {
    label: '不区分',
    value: 'ALL',
  },
  {
    label: '越库',
    value: 'CROSS',
  },
  {
    label: '不越库',
    value: 'NO_CROSS',
  },
];
export const crossDockingEN = {
  ALL: 'ALL',
  CROSS: 'CROSS',
  NO_CROSS: 'NO_CROSS',
};
// 是否区分温层
export const temperatureLayer = [
  {
    label: '不区分',
    value: 'ALL',
  },
  {
    label: '常温',
    value: 'NORMAL',
  },
  {
    label: '冷藏',
    value: 'REFRIGERATE',
  },
  {
    label: '冷冻',
    value: 'COLD',
  },
  {
    label: '恒温',
    value: 'CONSTANT',
  },
];
// 是否包含多订单
export const multiOrderType = [
  {
    label: '不区分',
    value: 'ALL',
  },
  {
    label: '1个订单',
    value: 'ORDER',
  },
  {
    label: '1条线路',
    value: 'LINE',
  },
  {
    label: '多条线路',
    value: 'MULTI_LINE',
  },
];
export const chooseAll = 'ALL';

export const TABLECOLUMN = [
  {
    label: '任务项',
    prop: 'taskName',
    minWidth: 120,
  },
  {
    label: '满足什么条件时生成',
    prop: 'condition',
    width: 450,
  },
  {
    label: '任务何时生成',
    prop: 'configTimeCondition',
    minWidth: 200,
  },
  {
    label: '分配方式',
    prop: 'allocateType',
    minWidth: 120,
  },
  {
    label: '任务作业分组',
    prop: 'configGroupType',
    minWidth: 140,
  },
  {
    label: '支持操作维度',
    prop: 'operationDimension',
    minWidth: 140,
  },
  {
    label: '作业方式',
    prop: 'configOperatorType',
    minWidth: 180,
  },
  {
    label: '任务权限',
    prop: 'configAuthorityType',
    width: 200,
  },
  {
    label: '任务执行时效',
    prop: 'taskExecutionEfficiency',
    width: 240,
  },
  {
    label: '任务项字段设置',
    prop: 'fieldSetting',
    width: 340,
  },
  {
    label: '任务项说明',
    prop: 'action',
    minWidth: 100,
    fixed: 'right',
  },
];
export const NODES = [
  {
    label: '进入节点时',
    value: 'IN_NODE',
  },
  {
    label: '节点完成时',
    value: 'COMPLETE_NODE',
  },
  {
    label: '关联任务全部完成时',
    value: 'COMPLETE_TASK',
  },
];
export const DIS_METHOD_OPTIONS = [
  {
    label: '手动领取',
    value: 'MANUAL',
  },
  {
    label: '自动',
    value: 'AUTOMATIC',
  },
];
export const WORK_MODE = [
  {
    label: '纸单作业',
    value: 'PAPER',
  },
  {
    label: 'PDA作业',
    value: 'PDA',
  },
  {
    label: '自动完成',
    value: 'AUTO',
  },
];
export const TASK_PER_OPTIONS = [
  {
    label: '项目组成员',
    value: 'PROJECT_TEAM_MEMBER',
  },
  {
    label: '有任务作业权限的人员',
    value: 'HAVE_TASK_ACTION_AUTHORITY',
  },
  // {
  //   label: '自动',
  //   value: 'AUTO',
  // },
];
export const RETURN_LOCATION_OPTIONS = [
  {
    label: '是',
    value: 'ENABLED',
  },
  {
    label: '否',
    value: 'DISABLED',
  },
];
export const TASK_TYPE = [
  {
    label: '异常警告',
    value: 'WARNING',
  },
  {
    label: '任务',
    value: 'TASK',
  },
];
// 任务作业分组全量枚举
export const TASK_WORK_GROUP = [
  {
    label: '波次',
    value: 'WAVE',
  },
  {
    label: '线路',
    value: 'LINE',
  },
  {
    label: '订单',
    value: 'ORDER',
  },
  {
    label: '温层',
    value: 'TEMPERATURE_LAYER',
  },
  {
    label: '库区',
    value: 'ZONE',
  },
  {
    label: '巷道',
    value: 'ROADWAY',
  },
  {
    label: '货主',
    value: 'CUSTOMER',
  },
  {
    label: '货品',
    value: 'GOODS',
  },
  {
    label: '是否越库',
    value: 'CROSS_DOCKING',
  },
  {
    label: '逻辑区',
    value: 'ABSTRACT_ZONE',
  },
  {
    label: '解冻标签',
    value: 'UN_FREEZE',
  },
];
export const NODE_TYPE = [
  {
    label: '创建入库单',
    value: 'RECEIPT_ORDER_CREATE_NODE',
  },
  {
    label: '到货预约',
    value: 'RECEIPT_RESERVATION_NODE',
  },
  {
    label: '到货登记',
    value: 'RECEIPT_CHECK_IN_NODE',
  },
  {
    label: '验收',
    value: 'RECEIPT_ORDER_ACCEPT_NODE',
  },
  {
    label: '上架',
    value: 'RECEIPT_ORDER_PUTAWAY_NODE',
  },
];
export const TRANSFER_TABLECOLUMN = [
  {
    label: '货主编码',
    prop: 'shipperCode',
  }, {
    label: '货主名称',
    prop: 'shipperName',
  },
];
export const MAX_LOCATION_TYPES = ['PICKING', 'PART_PICKING'];
export const NEED_REVIEW_TYPES = ['PART_PICKING', 'RECHECKED'];
export const IS_ENABLE = ['DELIVER_QUALITY_INSPECTION'];

// 入库
export const BOOLEAN_STATE = [
  {
    label: '是',
    value: true,
  },
  {
    label: '否',
    value: false,
  },
];
// 货品质量
export const GOODS_QUALITY_OPTIONS = [
  {
    label: '良品',
    value: 'GOOD',
  },
  {
    label: '不良品',
    value: 'BAD',
  },
  {
    label: '报废品',
    value: 'SCRAP',
  },
];
// 温层对应的暂存区
export const TEMPORARY_STOREHOUSE = [
  {
    label: '常温',
    value: 'normalLocationId',
    code: 'normalLocationCode',
    temporary: 'NORMAL',
  },
  {
    label: '冷藏',
    value: 'refrigerateLocationId',
    code: 'refrigerateLocationCode',
    temporary: 'REFRIGERATE',
  },
  {
    label: '冷冻',
    value: 'coldLocationId',
    code: 'coldLocationCode',
    temporary: 'COLD',
  },
  {
    label: '恒温',
    value: 'constantLocationId',
    code: 'constantLocationCode',
    temporary: 'CONSTANT',
  },
];
// 库位是否禁用
export const WAREHOUSE_ZONE_CODE = {
  ENABLED: '1',
  DISABLED: '0',
};
